import { EventBus } from 'ts-bus';

export {
  siteCreatedEvent,
  siteLastDataRefreshed,
  siteUrlUpdated,
  currentSiteChanged,
  currentSiteSet,
} from './site';

export {
  trackingCodeInstalled,
  trackingCodeModalOpened,
  trackingCodeVerificationFinished,
} from './tracking-code';

export { refreshData } from './data';

export { refetchRecordingsList } from './recordings';

export { interfaceLoaded } from './app';

export { profileUpdated } from './profile';

export { upgradeRequestSent } from './upsell';

export const bus = new EventBus();
